module.exports = __webpack_public_path__ + "img/ddLogo.73ab76d4.png";